import type { ComponentType } from "react";

import type { DashboardLayoutItem, DashboardWidgetMeta, WidgetSize } from "@/lib/api/dashboardLayout";
import { normalizeOrder } from "./grid";
import { WIDGET_COMPONENTS } from "./registry";
import type { WidgetProps } from "./widgets/kit";

export interface ResolvedWidget {
  item: DashboardLayoutItem;
  meta: DashboardWidgetMeta;
  /** The size actually used: the saved one, or the widget's default if the
   * saved one is not one it supports any more. */
  size: WidgetSize;
  Component: ComponentType<WidgetProps>;
}

/**
 * The widgets to draw, in order. Hidden ones, ones this user cannot see
 * (module off / no permission), ones the catalog no longer knows and ones this
 * build has no component for are all left out - never drawn broken, and never
 * fetched, because a widget that is not mounted runs no queries.
 */
export function resolveWidgets(items: DashboardLayoutItem[], catalog: DashboardWidgetMeta[], opts: { includeHidden?: boolean } = {}): ResolvedWidget[] {
  const metaById = new Map(catalog.map((m) => [m.id, m]));
  const out: ResolvedWidget[] = [];
  for (const item of normalizeOrder(items)) {
    if (!item.visible && !opts.includeHidden) continue;
    const meta = metaById.get(item.widget_id);
    const Component = WIDGET_COMPONENTS[item.widget_id];
    if (!meta || !Component || !meta.available) continue;
    const size = meta.sizes.includes(item.size) ? item.size : meta.default_size;
    out.push({ item, meta, size, Component });
  }
  return out;
}
